import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';

/**
 * Renders given component or element with given props
 *
 * Elements will be rendered with given props in 'props' parameter.
 *
 * Components will be rendered with props overridden in the following order
 * (from lowest to highest priority):
 *
 * - Given props in 'props' parameter
 * - Props that are already set on component (e.g. by end-user)
 *
 * The 'overrideProps' flag swaps this order.
 *
 * @param elementOrComponent - The component or element to render
 * @param props - The props to pass to the componen
 * @param overrideProps - Should the original props be overriden with the news ones
 */
var renderComponentOrElement = function renderComponentOrElement(elementOrComponent, props) {
  var overrideProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if ( /*#__PURE__*/React.isValidElement(elementOrComponent)) {
    var cloneProps = _extends({}, props, elementOrComponent.props);

    if (overrideProps) {
      cloneProps = _extends({}, elementOrComponent.props, props);
    }

    return /*#__PURE__*/React.cloneElement(elementOrComponent, cloneProps);
  } else {
    var Component = elementOrComponent;
    return /*#__PURE__*/React.createElement(Component, props);
  }
};
/**
 * Renders given node as such if it's a valid React element, otherwise
 * renders given fallback element
 * @param node - Preferred element
 * @param fallback - Fallback element
 */

var elementWithFallback = function elementWithFallback(node, fallback) {
  return /*#__PURE__*/React.isValidElement(node) ? node : fallback;
};

export { elementWithFallback, renderComponentOrElement };
